import $ from 'jquery'
import Owl from 'owl.carousel'

var slider = function() {

  function designCounter(event) {
    setTimeout(function() {
      var currentItem = $('#design-slider .owl-item.active .project-slider__content');
      var currentIndex = currentItem.attr('data-hash');
      currentItem.parents([4]).find('.slider-nav .mob-dots[href="#' + currentIndex + '"]').trigger('click');
    }, 50 );
  }

  function printCounter(event) {
    setTimeout(function() {
      var currentItem = $('#print-slider .owl-item.active .project-slider__content');
      var currentIndex = currentItem.attr('data-hash');
      currentItem.parents([4]).find('.slider-nav .mob-dots[href="#' + currentIndex + '"]').trigger('click');
    }, 50 );
  }

  $('#design-slider .home-slider').owlCarousel({
 		items: 1,
 		loop: false,
 		nav: false,
 		lazyLoad:true,
    animateOut: 'slideOutUp',
    animateIn: 'slideInUp',
    dots: true,
    dotsContainer: '.design-dot',
    onChange: designCounter,
    URLhashListener:true,
    responsiveClass:true,
    responsiveRefreshRate: 100,
    responsive:{
        0:{
            mouseDrag: true,
            animateIn: 'slideInRight',
            animateOut: 'slideOutRight',
        },
        800:{
            mouseDrag: false,
            animateIn: 'slideInUp',
            animateOut: 'slideOutUp',
        }
     }
 	});

 	$('#print-slider .home-slider').owlCarousel({
     rtl: true,
 		items: 1,
 		loop: false,
 		nav: false,
 		lazyLoad:true,
    dots: true,
    animateIn: 'slideInDown',
    animateOut: 'slideOutDown',
    dotsContainer: '.print-dot',
    onChange: printCounter,
    URLhashListener:true,
    responsiveClass:true,
    responsiveRefreshRate: 100,
    responsive:{
        0:{
            rtl: true,
            mouseDrag: true,
            animateIn: 'slideInLeft',
            animateOut: 'slideOutLeft',
        },
        800:{
            rtl: true,
            mouseDrag: false,
            animateIn: 'slideInDown',
            animateOut: 'slideOutDown',
        }
     }
 	});

  $('.parts-slider').each(function() {
    $(this).owlCarousel({
      margin: 40,
      nav: true,
      navText: ['<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" x="0px" y="0px" viewBox="0 0 18.6 35.6" style="enable-background:new 0 0 18.6 35.6;" xml:space="preserve"><style type="text/css">.st0{fill:#B2B5B6;}</style><g><path class="st0" d="M17.9,35.6c-0.1,0-0.3,0-0.4-0.1L0,17.9L17.8,0.1c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-17,17l16.8,16.8 c0.2,0.2,0.2,0.5,0,0.7C18.1,35.5,18,35.6,17.9,35.6z"/></g></svg>', '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.6 35.6" style="enable-background:new 0 0 18.6 35.6;" xml:space="preserve"> <style type="text/css">.st0{fill:#B2B5B6;}</style><g><path class="st0" d="M0.7,0C0.9,0,1,0,1.1,0.1l17.5,17.5L0.9,35.4c-0.2,0.2-0.5,0.2-0.7,0s-0.2-0.5,0-0.7l17-17L0.4,0.9 c-0.2-0.2-0.2-0.5,0-0.7C0.5,0,0.6,0,0.7,0z"/></g></svg>'],
      loop: true,
      mouseDrag: true,
      responsiveClass:true,
      responsive:{
          0:{
              items: 3,
          },
          800:{
              items: 5,
          }
      }
    });
  });

  var designSlider  = $('#design-slider .home-slider');
  var printSlider   = $('#print-slider .home-slider');

  function windowWidth() {
    return window.innerWidth;
  }


  $('.design-dot-wrap .owl-dot').on('click', function() {
    var nextItem = $(this).index();
    printSlider.trigger('to.owl.carousel', [nextItem, 1, true]);

    if(windowWidth() < 700) {
      $(this).addClass('active').siblings().removeClass('active')
      var dotCount = $('.print-dot-mob .mob-dots').length;
      var currentIndex = dotCount - nextItem;
      
      $('.print-dot-mob .mob-dots[data-count="' + currentIndex + '"]').addClass('active').siblings().removeClass('active');
    }
    
  });

  $('.print-dot-wrap .owl-dot').on('click', function() {
    var nextItem = $(this).index();
    designSlider.trigger('to.owl.carousel', [nextItem, 1, true]);

    if(windowWidth() < 700) {
      $(this).addClass('active').siblings().removeClass('active')
      var dotCount = $('.design-dot-mob .mob-dots').length;
      var currentIndex = dotCount - nextItem;
      
      $('.design-dot-mob .mob-dots[data-count="' + currentIndex + '"]').addClass('active').siblings().removeClass('active');
    }

  
  });
}

module.exports = slider;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js